import { Table } from 'antd';
import 'antd/dist/antd.css';
import { useEffect } from 'react';


const CustomTable = ({ data, columns, pagination, scrollable = true, loading, onPageChange, total, page, perPage = 10 }) => {

    const onChange = (page) => onPageChange(page)
    return (
        <div>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                loading={loading}
                columns={columns} dataSource={data} responsive
                pagination={pagination ? { onChange: onChange, total, pageSize: perPage } : false}
                scroll={{
                    x: scrollable,
                }}
            />
        </div>
    )
}

export default CustomTable